// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import i18n from './locales'
import request, { VueAxios, download, downloadByJson } from '@/utils/request'
import Highlight from './utils/highlight' // from 路径是highlight.js的路径，纯属自定义
import ProLayout, { PageHeaderWrapper } from '@ant-design-vue/pro-layout'
import themePluginConfig from '../config/themePluginConfig'
import { getDicts } from '@/api/system/dict/data'
import { apiLookupDataList } from "@/api/system/lookup/look-up-detail";
import { getConfigKey } from '@/api/system/config'
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree,
  timeText,
  lookupMeaning,
  parseFloatToFixed,
  countBackwards,
  getFlagName
} from '@/utils/common'
import {
  Empty,
  Space,
  message,
  Calendar,
  Cascader
} from 'ant-design-vue'
import lsmyLibs, { lsApiTable } from 'lsmy-libs'
import 'lsmy-libs/lib/lsmy-libs.css'
// mock
// WARNING: `mockjs` NOT SUPPORT `IE` PLEASE DO NOT USE IN `production` ENV.
// import './mock'
import bootstrap from './core/bootstrap'
import './core/lazy_use' // use lazy load components
import './permission' // permission control
import './utils/filter' // global filter
import './global.less' // global style
import permission from './directive/permission'
import moment from 'moment';
import Print from 'vue-print-nb'
import Page from '@/components/Page/index'
import GlobalSelect from '@/components/GlobalSelect/index'
import commonFunc from "@/utils/commonFunc";
import { hasPermi } from '@/utils/hasPermiByFunction'
import tableKey from '@/config/table-key'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import startTrack from '@/utils/set-track';

import {
  apiDeleteTableSettings, apiUpdateTableSettings, apiGetTableSetting
} from '@/services/module/util-api.js';

// 全局方法挂载
// 绑定 EventBus
Vue.prototype.$EventBus = new Vue()
Vue.prototype.getDicts = getDicts
Vue.prototype.getLookupListData = apiLookupDataList
Vue.prototype.getConfigKey = getConfigKey
Vue.config.productionTip = true
Vue.prototype.download = download
Vue.prototype.downloadByJson = downloadByJson
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree
Vue.prototype.$message = message
Vue.prototype.$moment = moment;
Vue.prototype.$timeText = timeText
Vue.prototype.$lookupMeaning = lookupMeaning
Vue.prototype.$parseFloatToFixed = parseFloatToFixed
Vue.prototype.$countBackwards = countBackwards
Vue.prototype.$getFlagName = getFlagName
Vue.prototype.$hasPermi = hasPermi
Vue.prototype.$closeTabPage = (...arg) => Vue.prototype.$EventBus.$emit('closeTabPage', ...arg);

Vue.prototype.event = new Vue()
Vue.use(Print)

Vue.use(Empty)
Vue.use(Calendar)
Vue.use(Cascader)
Vue.use(lsmyLibs, { request: request })
Vue.use(commonFunc)
// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)
// 代码高亮
Vue.use(Highlight)
// 权限控制
Vue.use(permission)
Vue.use(Viewer)

lsApiTable.lsApiTable.props.columnsConfig.default = () => ({
  checkApi: apiGetTableSetting,
  setApi: apiUpdateTableSettings,
  deleteApi: apiDeleteTableSettings,
  prefixSchemeKey: 'mom'
})

Vue.prototype.$TableKey = tableKey;

// use pro-layout components
Vue.component('pro-layout', ProLayout)
Vue.component('page-container', PageHeaderWrapper)
Vue.component('page-header-wrapper', PageHeaderWrapper)
Vue.component('a-space', Space)
Vue.component('Page', Page)
Vue.component('global-select', GlobalSelect)

window.umi_plugin_ant_themeVar = themePluginConfig.theme

// 修改lsApiTable extraHeight  放mixin改不动了
// if (Vue.options.components?.lsApiTable) {
//   console.log(Vue.options.components?.lsApiTable.options)
// }

async function render() {
  new Vue({
    router,
    store,
    i18n,
    // init localstorage, vuex
    // created: bootstrap,
    render: h => h(App),
    created() {
      startTrack(this)
      bootstrap()
    }
  }).$mount('#app')
}

render()
